import { render, staticRenderFns } from "./vote.vue?vue&type=template&id=da4d7596&scoped=true&lang=pug&"
import script from "./vote.vue?vue&type=script&lang=js&"
export * from "./vote.vue?vue&type=script&lang=js&"
import style0 from "./vote.vue?vue&type=style&index=0&id=da4d7596&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4d7596",
  null
  
)

export default component.exports